import { Box, Button } from 'grommet';
import { Edit } from 'grommet-icons';
import { auth$ } from 'modules/auth/stream/auth$';
import { User } from 'modules/auth/types';
import React from 'react';
import { useNavigate } from 'react-router';
import { connect } from 'rxbeach/react';

interface EditAssetButtonProps {
  shortid: string;
  label: string;
  user: User | null;
  type: string;
}

const EditAssetButton = ({ user, shortid, label, type }: EditAssetButtonProps) => {
  const navigate = useNavigate();
  if (!user) return null;
  return (
    <Box
      direction="row"
      justify="end"
      align="center"
      pad="small"
      alignSelf="end"
    >
      <Button
        size="small"
        onClick={() => navigate(`/admin/${type}/${shortid}`)}
        icon={<Edit />}
        label={label}
      />
    </Box>
  );
};

export default connect(EditAssetButton, auth$);
